













import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
	components: {},
})
export default class ExternalLinkButton extends Vue {
	@Prop(String)
	public route: string | undefined;
	@Prop(String)
	public buttonText: string | undefined;
	@Prop(Boolean)
	public disabled: boolean;
	@Prop(String)
	public buttonVariant: string | undefined;
	@Prop({ default: false })
	public block!: boolean;
	@Prop(String)
	public buttonIcon: string | undefined;
	@Prop(String)
	public size: string | undefined;
	@Prop(String)
	public target: string | undefined;
}
